const ASKS = [
  { quote: "Show me April's trial balance.", response: "TB delivered, balanced to zero" },
  { quote: "Reconcile last week's Revolut transactions.", response: "147 entries matched, 2 flagged" },
  { quote: "Who owes us money right now?", response: "Aged receivables, sorted by risk" },
  { quote: "Send invoice to Acme for last week's work.", response: "Drafted, branded, sent for review" },
  { quote: "What bills are due this week?", response: "Payables queued, ready to approve" },
  { quote: "Match this Stripe payout to my invoices.", response: "Pattern-matched across 23 lines" },
];

export function Asks() {
  return (
    <section className="asks" id="how">
      <div className="container">
        <div className="section-head">
          <div>
            <div className="section-num">&#167; 01 - The conversation</div>
            <h2 className="section-title">You ask. <em>It delivers.</em></h2>
          </div>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "11px", color: "var(--muted)", maxWidth: "280px", textAlign: "right" }}>
            No dashboards. No menus. No "let me get back to you on Monday."
          </div>
        </div>

        <div className="ask-grid">
          {ASKS.map((ask, idx) => (
            <div key={idx} className="ask">
              <p className="ask-quote">{ask.quote}</p>
              <div className="ask-response">{ask.response}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
